import Cursor, { CursorTypes } from 'editor/components/Cursor';
import Link from 'editor/components/Link';
import {
  MouseDownArgs,
  MouseMoveArgs,
  MouseUpArgs,
} from 'editor/systems/addSheetEvents/sheetEventHandlers';

const linkSelectionEvents = {
  mouseDown(args: MouseDownArgs): void {},

  mouseMove(args: MouseMoveArgs): void {
    const { hit, world, evt } = args;
    const cursorEntity = world.locate(Cursor);
    const linkHits = world
      .locateAll([Link])
      .map((entity) => entity.get(Link))
      .filter((l) => {
        return (
          hit.x > Math.min(l.bbox[0].valueOf(), l.bbox[2].valueOf()) &&
          hit.x < Math.max(l.bbox[0].valueOf(), l.bbox[2].valueOf()) &&
          hit.y > Math.min(l.bbox[1].valueOf(), l.bbox[3].valueOf()) &&
          hit.y < Math.max(l.bbox[1].valueOf(), l.bbox[3].valueOf())
        );
      });
    if (linkHits && linkHits.length > 0 && cursorEntity) {
      const cursorComp = cursorEntity.get(Cursor);
      if (cursorComp) {
        cursorComp.cursor = CursorTypes.Pointer;
      }
    }
  },

  mouseUp(args: MouseUpArgs): void {
    const { hit, world, evt } = args;
    const linkHits = world
      .locateAll([Link])
      .map((entity) => entity.get(Link))
      .filter((l) => {
        return (
          hit.x > Math.min(l.bbox[0].valueOf(), l.bbox[2].valueOf()) &&
          hit.x < Math.max(l.bbox[0].valueOf(), l.bbox[2].valueOf()) &&
          hit.y > Math.min(l.bbox[1].valueOf(), l.bbox[3].valueOf()) &&
          hit.y < Math.max(l.bbox[1].valueOf(), l.bbox[3].valueOf())
        );
      });
    if (linkHits && linkHits.length > 0) {
      linkHits[0].onClick();
    }
  },
};

export default linkSelectionEvents;
